import { useLocation } from "../../common/hooks/useLocation";
import { cartFlowSequence } from "../../common/miscellaneous/cartFlowSequence";
import { getPartnerPathnameClient } from "../../getPartnerPathnameClient";

function reverse(input: string) {
  return [...input.split("")].reverse().join("");
}

export function useFindLocationPage() {
  const { pathname } = useLocation();

  return cartFlowSequence.find(
    // `replace` removes trailing slashes
    (page) =>
      `${getPartnerPathnameClient(true)}${page.path}` ===
      // double reverse only because `/\/+$/` was falsly flaged by automated
      // ... check for denial of service
      reverse(reverse(pathname).replace(/^\/+/, ""))
  );
}
